<template>
  <div id="app">
    <router-view name="header"></router-view>
    <notifications group="notification_01" classes="vue-notification text-dark" :reverse="true"/>
    <router-view/>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: Segoe UI,Frutiger,Frutiger Linotype,Dejavu Sans,Helvetica Neue,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh!important;
  background-image: url("/img/cody-gallo.jpg");
  background-size: cover;
  overflow:hidden;
}
</style>
